import { render, staticRenderFns } from "./NoticeFooter.vue?vue&type=template&id=3342fd9d&scoped=true&"
import script from "./NoticeFooter.vue?vue&type=script&lang=js&"
export * from "./NoticeFooter.vue?vue&type=script&lang=js&"
import style0 from "./NoticeFooter.vue?vue&type=style&index=0&id=3342fd9d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3342fd9d",
  null
  
)

export default component.exports